import PropTypes from 'prop-types';
import React from 'react';
import { ContextCookieProvider } from './CookieContext';
import { startsWith } from 'Helpers/strings';

class CookieProvider extends React.Component {
    static propTypes = {
        children: PropTypes.any,
        cookies: PropTypes.object
    };

    static defaultProps = {
        cookies: {}
    };

    constructor() {
        super();
        this.get = this.get.bind(this);
        this.set = this.set.bind(this);
    }

    get(name) {
        let value;

        if (typeof document !== 'undefined' && document.cookie) {
            for (const cookie of document.cookie.split(';')) {
                const [n, v] = cookie.split('=').map(e => e.trim());

                if (name === n) {
                    value = decodeURIComponent(v);
                    break;
                }
            }
        }
        else if (typeof this.props.cookies[name] === 'object') {
            value = this.props.cookies[name];
        }
        else {
            value = (this.props.cookies[name])
                ? decodeURIComponent(this.props.cookies[name])
                : undefined;
        }

        if (typeof value == 'string' && startsWith(value, 'j:')) {
            try {
                value = JSON.parse(value.replace('j:', ''));
            }
            catch (e) {
                value = null;
            }
        }
        return value;
    }

    set(name, value, expires, path, domain, secure = true) {
        if (typeof document !== 'undefined') {
            switch (expires.constructor) {
                case Number:
                    expires = expires === Infinity ? '; expires=Fri, 31 Dec 9999 23:59:59 GMT' : `; max-age=${ expires }`;
                    break;
                case String:
                    expires = `; expires=${ expires }`;
                    break;
                case Date:
                    expires = `; expires=${ expires.toUTCString() }`;
                    break;
                default:
                    expires = '';
            }
            domain = domain ? `; domain=${ domain }` : '';
            path = path ? `; path=${ path }` : '';
            secure = secure ? '; secure' : '';
            document.cookie = `${ encodeURIComponent(name) }=${ encodeURIComponent(value) }${ expires }${ domain }${ path }${ secure }`;
        }
    }

    render() {
        const value = {
            get: this.get,
            set: this.set
        };

        return (
            <ContextCookieProvider value={ value }>
                {this.props.children}
            </ContextCookieProvider>
        );
    }
}

export default CookieProvider;
